import React, { useEffect } from "react"
import { useSelector } from "react-redux"

import LoginPrompt from "../login/LoginPrompt"
import { Box, Typography } from "@mui/material"
import AuditGrid from "./audit/AuditGrid"
import ActivityHeatMap from "./ActivityHeatMap"
import WorkcenterUpdate from "./WorkcenterUpdate"
import { MainBoxStyles, RowBoxStyles, HeatMapBoxStyles, AuditGridBoxStyles, LabelStyles } from "./styles/AdminStyles"
import resetHeaders from "../../Functions/ResetHeaders"

function AdminPage() {
    // Store Variables
    const auth = useSelector((state) => state.auth)
    const permissions = useSelector((state) => state.auth.permissions)

    useEffect(() => {
        if (auth.authenticated) {
            resetHeaders()
        }
    }, [auth])

    return (
        <>
            {auth.authenticated && permissions.ViewAdminPage ? (
                <Box sx={MainBoxStyles}>
                    {permissions.BulkAdmin && (
                        <Box sx={RowBoxStyles}>
                            <Box>
                                <WorkcenterUpdate />
                            </Box>
                        </Box>
                    )}
                    <Box sx={RowBoxStyles}>
                        <Box sx={HeatMapBoxStyles}>
                            <ActivityHeatMap />
                        </Box>
                    </Box>
                    <Box sx={AuditGridBoxStyles}>
                        <Typography variant="h4" sx={LabelStyles}>
                            Audit Log
                        </Typography>
                        <AuditGrid />
                    </Box>
                </Box>
            ) : (
                <LoginPrompt />
            )}
        </>
    )
}

export default AdminPage
